module.exports = __webpack_public_path__ + "static/img/jie2.f7dee3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jie2.jpg
// module id = nMS7
// module chunks = 1